// Host-only glue. The supplied diagnostic file and its scoring/export code stay unchanged.
function configureScorHost(config) {
  window.SCOR_DIAG_CONFIG = { apiBase: config.apiBase, getToken: () => null, pollMs: 15000 };
  const storage = window.localStorage;
  const prefix = `samanvai-scor:${config.ownerId}:`;
  // The document's optional offline cache must never be reused by another account.
  Object.defineProperty(window, 'localStorage', { value: {
    getItem: key => storage.getItem(prefix + key),
    setItem: (key, value) => storage.setItem(prefix + key, value),
    removeItem: key => storage.removeItem(prefix + key),
  } });
  window.addEventListener('message', event => {
    if (event.data?.type === 'scor:auth' && (event.origin !== config.origin || event.source !== window.parent)) {
      event.stopImmediatePropagation();
    }
  }, true);
  // Add automation labels at runtime without editing the provided HTML source.
  const labelControls = () => {
    const counts = {};
    document.querySelectorAll('button,a,input,select,textarea,[role="alert"],#save,#toast').forEach(el => {
      const key = ['scor', el.id || el.getAttribute('data-act') || el.name || el.tagName,
        el.getAttribute('data-v') || el.getAttribute('data-k') || ''].join('-').toLowerCase().replace(/[^a-z0-9-]/g, '-');
      counts[key] = (counts[key] || 0) + 1;
      const id = `${key}-${counts[key]}`;
      if (el.getAttribute('data-testid') !== id) el.setAttribute('data-testid', id);
    });
  };
  document.addEventListener('DOMContentLoaded', () => {
    labelControls();
    new MutationObserver(labelControls).observe(document.body, { childList: true, subtree: true });
  });
}

export const scorDocument = (html, ownerId) => {
  const config = JSON.stringify({ apiBase: `${process.env.REACT_APP_BACKEND_URL}/api`, ownerId,
    origin: window.location.origin }).replace(/</g, '\\u003c');
  const bootstrap = `<script>(${configureScorHost.toString()})(${config});</script>`;
  return html.replace(/<head(?:\s[^>]*)?>/i, head => head + bootstrap);
};